import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import NotFound from "./pages/NotFound";
import FinancialChatInterface from "./pages/financial-chat-interface";
import LoginPage from "./pages/auth/LoginPage";
import SignUpPage from "./pages/auth/SignUpPage";
import ProtectedRoute from "./components/ProtectedRoute";
import PeriodSettings from "pages/PeriodSettings";
import FinancialDashboard from "pages/Dashboard/FinancialDashboard";
import FinancialMentorsLanding from "pages/FinancialMentorsLanding";
import Home from "pages/landing/Home";
import PricingCards from "pages/plans";
import ProfilePage from "pages/profile/ProfilePage";
const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Login page */}
          <Route path="/" element={<Home />} />

          <Route path="/login" element={<LoginPage />} />

          {/* Protected chat interface */}
          {/* <Route path="/chat" element={<ProtectedRoute><FinancialChatInterface /></ProtectedRoute>}/> */}

          <Route path="/chat" element={<FinancialChatInterface />}/>

          <Route path="/signup" element={<SignUpPage />} />
          
          <Route path='/target_time' element={<PeriodSettings />} />

          <Route path="/dashboard" element={<FinancialDashboard />} />

          <Route path="/mentors" element={<FinancialMentorsLanding />} />

          <Route path="/plans" element={<PricingCards />} />

          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<NotFound />} />


        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
